<template>
  <DashboardLayout>
    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <!-- Dynamic Parent -->
      <router-link v-if="fromNotifications"
        :to="{ name: 'ViewPendingNotifications', query: { entityType: route.query.entityType, statusInd: route.query.statusInd } }"
        class="mb-0 main-identifier fw-semibold text-decoration-none" title="Go back to Notifications">
        Notifications
      </router-link>

      <router-link v-else :to="{ name: 'ViewMemos' }" class="mb-0 main-identifier fw-semibold text-decoration-none"
        title="Go back to Memos">
        Memos
      </router-link>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Approve Memo Update</p>
    </div>

    <div class="d-flex justify-content-center mb-5">

      <div class="form-outer">
        <form @submit.prevent="step === totalSteps ? handleSubmit() : handleNext()">
          <div class="crud-form position-relative">

            <div class="form-inner mb-2">
              <div class="form-header d-flex justify-content-between align-items-center">
                <h1 class="mb-0">Memo Update Approval</h1>
              </div>

              <!-- Marquee Notice -->
              <div v-if="hasAssociatedPaymentVoucher" class="marquee-wrapper">
                <div class="marquee-content">
                  <p>
                    <span class="material-symbols-outlined">
                      asterisk
                    </span> This memo has an associated Payment Voucher
                  </p>
                  <p>
                    <span class="material-symbols-outlined">
                      asterisk
                    </span>This memo has an associated Payment Voucher
                  </p>
                  <p>
                    <span class="material-symbols-outlined">
                      asterisk
                    </span>This memo has an associated Payment Voucher
                  </p>
                </div>
              </div>

              <div class="memo-content-area position-relative">
                <div v-if="!isDataLoaded" class="loading-overlay text-center">
                  <div class="spinner-border text-primary" role="status" aria-hidden="true"></div>
                  <p class="mt-2 mb-0 text-muted">Loading memo details...</p>
                </div>

                <div v-if="isDataLoaded" class="form-body mt-3 mb-3">
                  <div v-if="step === 1">

                    <div class="form-row">
                      <div class="form-row-label">
                        <label for="fileName" class="form-label">File Title</label>
                      </div>
                      <div class="form-row-input">
                        <input id="fileName" type="text" class="form-control form-view-only-input"
                          v-model="form.fileTitle" placeholder="" readonly />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-row-label">
                        <label for="fileNumber" class="form-label">File Number</label>
                      </div>
                      <div class="form-row-input">
                        <input id="fileNumber" type="text" class="form-control form-view-only-input"
                          v-model="form.fileNumber" placeholder="" readonly />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-row-label">
                        <label for="createdDate" class="form-label">Created Date</label>
                      </div>
                      <div class="form-row-input">
                        <input id="createdDate" type="text" class="form-control form-view-only-input"
                          :value="formatDate(form.createdDate)" placeholder="" readonly />
                      </div>
                    </div>

                    <!-- <div class="form-row">
                        <div class="form-row-label">
                          <label for="Sector" class="form-label">Sector:</label>
                        </div>
                        <div class="form-row-input d-flex align-items-center gap-2">
                          <select class="form-select" v-model="sector" @change="onSectorChange" required>
                            <option value="" disabled>- Select Sector -</option>
                            <option v-for="sector in sectors" :key="sector.id" :value="sector.id">{{ sector.code }} ({{
                              sector.name }})</option>
                          </select>
                        </div>
                      </div> -->

                    <div class="form-row" v-if="memo.oldOriginatingMda !== null && memo.oldOriginatingMda !== undefined && memo.oldOriginatingMda.trim() !== ''">
                      <div class="form-row-label">
                        <label for="OriginatingMda" class="form-label">Old Originating MDA</label>
                      </div>
                      <div class="form-row-input d-flex align-items-center gap-2">
                        <input id="OriginatingMda" type="text" class="form-control form-view-only-input"
                          v-model="memo.oldOriginatingMda" placeholder="" readonly />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-row-label">
                        <label for="OriginatingMda" class="form-label">New Originating MDA</label>
                      </div>
                      <div v-if="mdaFieldEditable" class="form-row-input d-flex align-items-center gap-2">
                        <select class="form-select editable" v-model="mda" @change="onMdaChange" required>
                          <option value="" disabled>- Select MDA -</option>
                          <option v-for="mda in mdas" :key="mda.id" :value="mda.id">{{ mda.name }}</option>
                        </select>
                        <span class="material-symbols-outlined edit-icon-filled" title="Edit Originating MDA"
                          @click="toggleEditField('mda')">
                          edit
                        </span>
                      </div>

                      <div v-else class="form-row-input d-flex align-items-center gap-2">
                        <input id="OriginatingMda" type="text" class="form-control form-view-only-input"
                          v-model="form.originatingMda" placeholder="" readonly />
                        <span class="material-symbols-outlined edit-icon" title="Edit Originating MDA"
                          @click="toggleEditField('mda')">
                          edit
                        </span>
                      </div>
                    </div>

                    <div class="form-row" v-if="memo.oldAmountApproved !== 0 && memo.oldAmountApproved !== undefined">
                      <div class="form-row-label">
                        <label for="amountApproved" class="form-label">Old Amount Approved</label>
                      </div>
                      <div class="form-row-input d-flex align-items-center gap-2">
                        <input id="amountApproved" type="text" class="form-control form-view-only-input"
                          :value="'₦' + formatCurrency(memo.oldAmountApproved || 0).toLocaleString()" placeholder="" />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-row-label">
                        <label for="amountApproved" class="form-label">Amount Approved</label>
                      </div>
                      <div v-if="amountApprovedFieldEditable" class="form-row-input d-flex align-items-center gap-2">
                        <input id="amountApproved" type="text" class="form-control editable"
                          :value="'₦' + formatCurrency(form.amountApproved || 0)" inputmode="numeric"
                          @input="onAmountApprovedInput" title="Click to edit"
                          :placeholder="'₦' + formatCurrency(form.amountApproved || 0).toLocaleString()" />
                        <span class="material-symbols-outlined edit-icon-filled" title="Edit Amount Approved"
                          @click="toggleEditField('amountApproved')">
                          edit
                        </span>
                      </div>

                      <div v-else class="form-row-input d-flex align-items-center gap-2">
                        <input id="amountApproved" type="text" class="form-control form-view-only-input"
                          :value="'₦' + formatCurrency(form.amountApproved || 0).toLocaleString()" placeholder="" />
                        <span class="material-symbols-outlined edit-icon" title="Edit Amount Approved"
                          @click="toggleEditField('amountApproved')">
                          edit
                        </span>
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-row-label">
                        <label class="form-label">Remarks</label>
                      </div>
                      <div class="form-row-input">
                        <textarea type="text" class="form-control" v-model="form.remarks"
                          placeholder="">
                        </textarea>
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-row-label">
                        <label class="form-label">Status</label>
                      </div>
                      <div class="form-row-input">
                        <input type="text" class="form-control form-view-only-input" :value="status" readonly>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>


            <!-- Main Actions Container -->
            <div v-if="rolesLoaded && isDataLoaded && isEditable && !isRejected && !appraisalInitiated"
              class="action-buttons-container">
              <div v-if="step === totalSteps" class="action-buttons-wrapper">
                <!-- Group Head, QSSU, Super Admin -->
                <template v-if="rolesLoaded && hasAccess(['qssu', 'groupMember', '', 'groupHead']) && !isReturned">
                  <!-- Initiate Appraisal - Only show if memoId exists -->
                  <div v-if="form.memoId" class="action-button">
                    <button type="button" class="btn btn-success accept-btn" @click="handleApprove"
                      :disabled="loadingApprove || submitted" >
                      <span v-if="loadingApprove" class="spinner-border spinner-border-sm me-2" role="status"
                        aria-hidden="true"></span>
                        {{ (loadingApprove ? 'Approving Edit...' : 'Approve') }}
                    </button>
                  </div>

                  <!-- Reject Memo -->
                  <div class="action-button" v-if="!hasAssociatedPaymentVoucher">
                    <button type="button" class="btn btn-danger reject-btn" @click="showRejectModal"
                      :disabled="loadingReject || submitted">
                      <span v-if="loadingReject" class="spinner-border spinner-border-sm me-2" role="status"
                        aria-hidden="true"></span>
                      {{ (loadingReject ? 'Rejecting...' : 'Reject') }}
                    </button>
                  </div>
                </template>

              </div>
            </div>


          </div>
        </form>
      </div>
    </div>
  </DashboardLayout>
</template>

<script setup>
import { ref, reactive, onMounted, watch, computed } from 'vue'
import axios from 'axios'
import Swal from 'sweetalert2';
import DashboardLayout from '../layout/DashboardLayout.vue'
import Cookies from 'js-cookie';
import { useRoute, useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';
import { bus } from '@/eventBus'
const userStore = useUserStore()

const router = useRouter();

const root_api_url = process.env.VUE_APP_API_ROOT_URL
const totalSteps = 1
const step = ref(1)
const loadingApprove = ref(false)
const loadingReject = ref(false)
const submitted = ref(false)
const hasSavedRemark = ref(false)
const isEditable = ref(true)
const isEdited = ref(false)
const isRejected = ref(false)
const isReturned = ref(false)
const isPendingApproval = ref(false)
const route = useRoute();
const id = route.params.id;
const actionRemarks = ref('')
const mdas = ref([])
const mda = ref('')
// const canGoToApproval = computed(() => {
//   return appraisalInitiated.value && hasAccess(['qssu', 'groupMember', '', 'groupHead'])
// })

const fromNotifications = computed(() => route.query.from === 'ViewPendingNotifications' && route.query.entityType && route.query.statusInd)
const rolesLoaded = ref(false)
const isDataLoaded = ref(false)

const mdaFieldEditable = ref(false)
const amountApprovedFieldEditable = ref(false)

function toggleEditField(field) {
  if (field === 'mda') {
    fetchMDAs(memo.groupTypeId)
    mdaFieldEditable.value = !mdaFieldEditable.value
  } else if (field === 'amountApproved') {
    amountApprovedFieldEditable.value = !amountApprovedFieldEditable.value
  }
}

const fetchMDAs = async (grpTypeId) => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/mda/group/${grpTypeId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    mdas.value = response.data.map(mda => ({
      id: mda.id,
      name: mda.name,
    }))

  } catch (error) {
    console.error('Failed to fetch roles:', error)
  }
}

function onMdaChange() {
  const selected = mdas.value.find(item => item.id === mda.value)
  form.originatingMda = selected ? selected.name : ''
  form.mdaId = selected ? selected.id : ''
}

const memo = reactive({
  id: '',
  fileTitle: '',
  fileNumber: '',
  createdDate: '',
  sector: '',
  mdaId: '',
  originatingMda: '',
  amountApproved: '',
  grpHeadGrpMemRemarks: '',
  memoEditable: '',
  groupTypeId: '',
  orgCode: '',
  ticketId: '',
  lastModifiedDate: '',
  createdBy: '',
  lastModBy: '',
  userId: '',
  isEditableInd: '',
  memoReturned: '',
  memoRejected: '',
  grpHeadGrpMemRemarksDate: '',
  grpHeadGrpMemId: '',
  version: '',
  pvMemoId: '',
  payVoucherId: '',
  oldMdaId: '',
  oldOriginatingMda: '',
  oldAmountApproved: '',
  pendingApprovalInd: '',
  pendingApproval: '',
  fileTrackerNumber: '',
})

const form = reactive({
  id: '',
  fileTitle: '',
  fileNumber: '',
  createdDate: '',
  sectorId: '',
  mdaId: '',
  originatingMda: '',
  amountApproved: '',
  grpHeadGrpMemRemarks: '',
  memoId: '',
  remarks: '',
})

watch(
  () => [form.mdaId, form.originatingMda, form.amountApproved],
  ([newMdaId, newOriginatingMda, newAmountApproved]) => {
    if (newMdaId === memo.oldMdaId && newOriginatingMda === memo.oldOriginatingMda && Number(newAmountApproved) === Number(memo.oldAmountApproved)) {
      isEdited.value = false
    } else {
      isEdited.value = newMdaId !== memo.oldMdaId || newOriginatingMda !== memo.oldOriginatingMda || Number(newAmountApproved) !== Number(memo.oldAmountApproved)
    }
  }
)

const hasAssociatedPaymentVoucher = computed(() => {
  return (memo.pvMemoId !== null && memo.pvMemoId !== undefined && String(memo.pvMemoId).trim() !== '') ||
    (memo.payVoucherId !== null && memo.payVoucherId !== undefined && String(memo.payVoucherId).trim() !== '')
})

const fetchMemo = async () => {
  const token = Cookies.get('auth_token');
  try {
    const { data } = await axios.get(`${root_api_url}/appraisal/memo/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    form.memoId = data.id

    memo.id = data.id
    memo.isEditableInd = data.isEditableInd
    memo.memoEditable = Boolean(data.isEditableInd)
    memo.groupTypeId = data.groupTypeId
    memo.orgCode = data.orgCode
    memo.ticketId = data.ticketId
    memo.memoRejected = data.memoRejectedInd
    memo.memoReturned = data.memoReturnedInd
    memo.lastModifiedDate = data.lastModifiedDate
    memo.createdBy = data.createdBy
    memo.lastModifiedBy = data.lastModifiedBy
    memo.userId = data.userId
    memo.grpHeadGrpMemRemarksDate = data.grpHeadGrpMemRemarksDate
    memo.grpHeadGrpMemId = data.grpHeadGrpMemId
    memo.version = data.version
    memo.pvMemoId = data.pvMemoId
    memo.payVoucherId = data.payVoucherId
    memo.oldMdaId = data.oldMdaId
    memo.oldOriginatingMda = data.oldOriginatingMda
    memo.oldAmountApproved = data.oldAmountApproved
    memo.pendingApprovalInd = data.pendingApprovalInd
    memo.pendingApproval = Boolean(data.pendingApprovalInd)
    form.fileTitle = data.fileTitle
    form.fileNumber = data.fileNumber
    form.createdDate = data.createdDate
    form.mdaId = data.mdaId
    form.sectorId = data.sectorId
    form.originatingMda = data.originatingMda
    form.amountApproved = data.amountApproved
    form.fileTrackerNumber = data.fileTrackerNumber
    form.grpHeadGrpMemRemarks = data.grpHeadGrpMemRemarks
    form.remarks = data.remarks

    isReturned.value = data.memoReturnedInd
    isEditable.value = data.isEditableInd
    isRejected.value = data.memoRejectedInd
    isPendingApproval.value = data.pendingApprovalInd

    isDataLoaded.value = true

    await fetchAppraisalByFileNumber();
  } catch (error) {
    console.error('Error fetching memo:', error);
    isDataLoaded.value = true
  }
};

const handleApprove = async () => {
  const token = Cookies.get('auth_token');

  loadingApprove.value = true;
  submitted.value = true;

  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

  const memoData = {
    ...form,
    id: id,
    fileTitle: form.fileTitle,
    fileNumber: form.fileNumber,
    createdDate: form.createdDate,
    mdaId: form.mdaId,
    sectorId: form.sectorId,
    originatingMda: form.originatingMda,
    amountApproved: form.amountApproved,
    orgCode: memo.orgCode,
    groupTypeId: memo.groupTypeId,
    ticketId: memo.ticketId,
    lastModifiedDate: memo.lastModifiedDate,
    createdBy: memo.createdBy,
    lastModifiedBy: memo.lastModifiedBy,
    userId: memo.userId,
    grpHeadGrpMemId: userStore.profile?.id,
    version: memo.version,
    pvMemoId: memo.pvMemoId,
    payVoucherId: memo.payVoucherId,
    hasAssociatedPaymentVoucher: hasAssociatedPaymentVoucher.value,
    fileTrackerNumber: memo.fileTrackerNumber,
    remarks: form.remarks,
  }

  console.log('Submitting approval with data:', memoData)
  try {
    const { data } = await axios.put(`${root_api_url}/appraisal/memo/approve/${id}`, memoData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    console.log('Approve response:', data);
    Swal.fire({
      html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Memo Edit Approved Successfully</p> `,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    }).then(() => {
      hasSavedRemark.value = true
      bus.emit('refresh-notifications')
      router.push({ name: 'ViewMemos' })
    });

  } catch (error) {
    if (error.response) {
      Swal.fire({
        html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>${error?.response?.data?.errorMessage || error?.response?.data?.error || error?.response?.data?.message || 'Unexpected error occurred, kindly contact administrator.'}</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    } else {
      Swal.fire({
        html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>Unexpected error occurred, kindly contact administrator.</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    }
  } finally {
    loadingApprove.value = false;
    submitted.value = false;
  }
}

const showRejectModal = async () => {
  actionRemarks.value = ''
  await Swal.fire({
    title: 'Reject Memo',
    html: `
        <div class="form-group">
          <label for="rejectRemarks" class="form-label">Remarks <span class="text-danger">*</span></label>
          <textarea id="rejectRemarks" v-model="actionRemarks" class="form-control" rows="4"
            placeholder="Please provide your remarks for rejecting this memo..." required></textarea>
        </div>
        <div class="modal-footer">
          <button type="button" id="rejectMemoButton" class="btn btn-danger">
            Reject Memo
          </button>
        </div>`,
    showCancelButton: false,
    showConfirmButton: false,
    showCloseButton: true,
    customClass: {
      popup: 'ogpabs-swal',
      htmlContainer: 'ogpabs-swal-html'
    },
    didOpen: () => {
      const btn = document.getElementById('rejectMemoButton')
      btn.addEventListener('click', async () => {
        const remarks = document.getElementById('rejectRemarks').value.trim()

        if (!remarks) {
          Swal.showValidationMessage('Remarks cannot be empty')
          return
        }

        actionRemarks.value = remarks
        await handleReject()
      })
    },
  })
}


const handleReject = async () => {
  const token = Cookies.get('auth_token');

  loadingReject.value = true;
  submitted.value = true;

  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

  if (!actionRemarks.value.trim()) {
    Swal.fire({
      html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>Remark can not be empty</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    });

    loadingReject.value = false;
    submitted.value = false;
    return;
  }

  const memoData = {
    ...form,
    id: id,
    fileTitle: form.fileTitle,
    fileNumber: form.fileNumber,
    createdDate: form.createdDate,
    mdaId: form.mdaId,
    sectorId: form.sectorId,
    originatingMda: form.originatingMda,
    amountApproved: form.amountApproved,
    orgCode: memo.orgCode,
    groupTypeId: memo.groupTypeId,
    ticketId: memo.ticketId,
    isEditableInd: 1,
    memoRejectedInd: 1,
    grpHeadGrpMemRemarks: actionRemarks.value.trim(),
    lastModifiedDate: memo.lastModifiedDate,
    createdBy: memo.createdBy,
    lastModifiedBy: memo.lastModifiedBy,
    userId: memo.userId,
    grpHeadGrpMemRemarksDate: new Date().toISOString(),
    grpHeadGrpMemId: userStore.profile?.id,
    version: memo.version,
    pvMemoId: memo.pvMemoId,
    payVoucherId: memo.payVoucherId,
    hasAssociatedPaymentVoucher: hasAssociatedPaymentVoucher.value,
    fileTrackerNumber: memo.fileTrackerNumber,

  }

  try {
    const { data } = await axios.put(`${root_api_url}/appraisal/memo/${id}`, memoData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    Swal.fire({
      html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Memo Rejected Successfully</p> `,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    }).then(() => {
      hasSavedRemark.value = true
      bus.emit('refresh-notifications')
      isRejected.value = Boolean(data.memoRejectedInd);
      form.gHOrGMRemarks = actionRemarks.value.trim()
      actionRemarks.value = ''
      router.push({ name: 'ViewMemos' })
    });

  } catch (error) {
    if (error.response) {
      Swal.fire({
        html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>${error?.response?.data?.errorMessage || error?.response?.data?.error || error?.response?.data?.message || 'Unexpected error occurred, kindly contact administrator.'}</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    } else {
      Swal.fire({
        html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>Unexpected error occurred, kindly contact administrator.</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    }
  } finally {
    loadingReject.value = false;
    submitted.value = false;
  }
}

/**
 * Handle Amount Approved input
 */
const MAX_SAFE_RAW = Number.MAX_SAFE_INTEGER.toString(); // "9007199254740991"

function onAmountApprovedInput(e) {
  let raw = e.target.value.replace(/\D/g, '');

  if (raw === '') {
    form.amountApproved = '';
    e.target.value = '';
    return;
  }

  // Prevent adding more digits than safe
  if (raw.length > MAX_SAFE_RAW.length ||
    (raw.length === MAX_SAFE_RAW.length && raw > MAX_SAFE_RAW)) {
    raw = MAX_SAFE_RAW; // trim to safe max
  }

  const num = parseInt(raw, 10) / 100;
  form.amountApproved = Number(num.toFixed(2));
  e.target.value = formatCurrency(form.amountApproved);
}

function formatCurrency(val) {
  if (val === '' || val === null) return '';
  const num = parseFloat(val).toFixed(2);
  return Number(num).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

const formatDate = (dateString) => {
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}

const allRoles = [
  'qssu',
  'dirOfBudget',
  'perSec',
  'commOfBAndP',
  'registryOfficer',
  'groupHead',
  'groupMember',
];

const hasAccess = (required) => {
  const profileRoles = userStore.profile?.role || {};

  const userHasRole = (role) => !!profileRoles[role];

  if (!required || required.length === 0) return true;

  if (required.includes('')) {
    const otherRoles = required.filter(role => role !== '');

    if (otherRoles.some(role => userHasRole(role))) return true;

    const isFreeUser = Object.keys(profileRoles).every(r => !allRoles.includes(r) || profileRoles[r] === false);
    if (isFreeUser) return true;

    return false;
  }

  return required.some(role => userHasRole(role));
}


const appraisalInitiated = ref(false)

const fetchAppraisalByFileNumber = async () => {
  try {
    const res = await axios.get(`${root_api_url}/appraisal/appraisal/memo/${form.fileNumber}`)

    if (res.data) {
      appraisalInitiated.value = true
    }
  } catch (err) {
    console.error('Error fetching appraisal by file number:', err)
    appraisalInitiated.value = false
  }
}

const status = computed(() => {
  if (appraisalInitiated.value) {
    return 'Appraisal Initiated'
  }

  if (isRejected.value) return 'Rejected'
  if (isReturned.value) return 'Returned'

  return 'Pending'
})

onMounted(async () => {
  await fetchMemo()
  document.title = "View Memo Update Approval"

  if (userStore.profile?.role) {
    rolesLoaded.value = true
  } else {

    const stop = watch(
      () => userStore.profile?.role,
      (val) => {
        if (val) {
          rolesLoaded.value = true
          stop()
        }
      },
      { immediate: true }
    )
  }
})

</script>

<style scoped>
/* Marquee Styles */
.marquee-wrapper {
  width: 100%;
  overflow: hidden;
  background-color: #f2ffe6;
  padding: 0.5rem 0;
}

.marquee-content {
  display: inline-flex;
  white-space: nowrap;
  animation: marquee 20s linear infinite;
}

.marquee-content span {
  display: inline-block;
  padding: 0 2rem;
  font-size: 1rem;
  font-weight: 500;
  color: #856404;
}

.marquee-content:hover {
  animation-play-state: paused;
}

.memo-content-area {
  min-height: 280px;
}

.loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 20;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  pointer-events: all;
}

/* Form Container */
.form-outer {
  width: 100%;
  max-width: 800px;
  /* padding: 1rem; */
}

.crud-form {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* .form-inner {
  padding: 1.5rem;
} */

.form-header h1 {
  font-size: 1.5rem;
  color: #333;
}

/* Form Row Layout */
.form-row {
  display: flex;
  margin-bottom: 1.5rem;
  gap: 1rem;
  align-items: flex-start;
}

.form-row-label {
  flex: 0 0 30%;
  text-align: right;
  padding-top: 0.5rem;
}

.form-row-label label {
  font-weight: 600;
    color: var(--color);
  margin-bottom: 0;
}

.form-row-input {
  flex: 1;
}

.view-only-input {
  border: none !important;
  background-color: transparent;
  padding-left: 0;
  cursor: default;
  pointer-events: none;
  color: #212529;
  font-size: 1rem;
  padding-right: 0;
  box-shadow: none !important;
}

/* Action Buttons Container */
.action-buttons-container {
  padding: 1.5rem;
  border-top: 1px solid var(--border);
  background-color: var(--bg);
}

.action-buttons-wrapper {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.action-button {
  flex: 0 0 auto;
}

.action-button button {
  min-width: 140px;
  white-space: nowrap;
}

/* Button Styles */
.btn {
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.submit-btn {
  background-color: #007bff !important;
  border-color: #007bff !important;
}

.submit-btn:hover {
  background-color: #0056b3 !important;
}

.accept-btn {
  background-color: #28a745 !important;
  border-color: #28a745 !important;
}

.accept-btn:hover {
  background-color: #218838 !important;
}

.return-btn {
  background-color: #ffc107 !important;
  border-color: #ffc107 !important;
  color: #212529 !important;
}

.return-btn:hover {
  background-color: #e0a800 !important;
}

.editable {
  border: 1px dashed #aaa;
  background-color:var(--table-bg-head);
}

.edit-icon {
  font-size: 16px;
  color: #aaa;
  cursor: pointer;
}

.edit-icon-filled {
  font-variation-settings:
    'FILL' 1,
    'wght' 400,
    'GRAD' 0,
    'opsz' 24
}


/* Tablet Responsiveness (768px - 1024px) */
@media screen and (max-width: 1024px) {
  .form-outer {
    max-width: 100%;
    /* padding: 0.75rem; */
  }

  /* .form-inner {
    padding: 1.25rem;
  } */

  .form-row-label {
    flex: 0 0 40%;
  }
}

/* Mobile Responsiveness (below 768px) */
@media screen and (max-width: 768px) {
  /* .form-outer {
    padding: 0.5rem;
  }

  .form-inner {
    padding: 1rem;
  } */

  .form-header h1 {
    font-size: 1.25rem;
  }

  /* Stack label and input vertically on mobile */
  .form-row {
    flex-direction: column;
    gap: 0.5rem;
    margin-bottom: 1.25rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #e9ecef;
  }

  .form-row-label {
    flex: none;
    text-align: left;
    padding-top: 0;
  }

  .form-row-label label {
    font-size: 0.875rem;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .form-row-input {
    flex: none;
    width: 100%;
  }

  .view-only-input {
    font-size: 0.95rem;
    padding: 0.25rem 0;
    font-weight: 500;
  }

  /* Action buttons stack on mobile */
  .action-buttons-container {
    padding: 1rem;
  }

  .action-buttons-wrapper {
    flex-direction: column;
    gap: 0.75rem;
  }

  .action-button {
    width: 100%;
  }

  .action-button button {
    width: 100%;
    min-width: 100%;
  }

  /* Page identifier adjustments */
  .page-identifier {
    font-size: 0.875rem;
  }

  .page-identifier .material-symbols-outlined {
    font-size: 1.25rem;
  }
}

/* Small Mobile (below 480px) */
@media screen and (max-width: 480px) {
  /* .form-outer {
    padding: 0.25rem;
  }

  .form-inner {
    padding: 0.75rem;
  } */

  .form-header h1 {
    font-size: 1.125rem;
  }

  .form-row {
    margin-bottom: 1rem;
    padding-bottom: 0.75rem;
  }

  .form-row-label label {
    font-size: 0.8125rem;
  }

  .view-only-input {
    font-size: 0.875rem;
  }

  .action-buttons-container {
    padding: 0.75rem;
  }

  .btn {
    padding: 0.625rem 1rem;
    font-size: 0.875rem;
  }
}

/* Loading State */
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.15em;
}

/* Print Styles */
@media print {

  .action-buttons-container,
  .page-identifier {
    display: none !important;
  }

  .form-outer {
    max-width: 100%;
    box-shadow: none;
  }

  .form-row {
    page-break-inside: avoid;
  }
}
</style>
